/* Bloomstep (#143): gallery, colour / size / pack picker, cart, sticky bar, reveal, FAQ tabs, dialogs. No dependencies.
   tai-dung:bo-qua theme asset chạy trong trình duyệt của khách (Shopify Ajax Cart API cùng origin), không phải script Node: tools/lib/storefront.mjs không nạp được ở đây.
   Horizon scrolls .page-wrapper on desktop (window never fires scroll, #119 R5-2): everything here uses IntersectionObserver and
   scrollIntoView, never window scroll events. */
(() => {
  document.documentElement.classList.add('bs-js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const goTo = (el, block = 'start') => el && el.scrollIntoView({ behavior: smooth, block });

  /* reveal: transform only, content always visible; stagger siblings 70 ms */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('[data-bs-reveal]').forEach((el) => {
    const sib = el.parentElement ? $$(':scope > [data-bs-reveal]', el.parentElement).indexOf(el) : 0;
    el.style.setProperty('--d', `${Math.min(sib, 6) * 70}ms`);
    if (io) io.observe(el); else el.classList.add('is-in');
  });

  /* bridges + any in-page link */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    const t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    if (a.dataset.bsTier) { const r = $(`input[name="bs-tier"][value="${a.dataset.bsTier}"]`); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
    goTo(a.hasAttribute('data-bs-to-buy') ? ($('.bs-buy') || t) : t);
  });

  /* dialogs */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-bs-open]');
    if (o) { const d = document.getElementById(o.dataset.bsOpen); if (d && d.showModal) d.showModal(); return; }
    const c = e.target.closest('[data-bs-close]');
    if (c) c.closest('dialog')?.close();
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* FAQ: "All" first and selected on load */
  $$('[data-bs-faq]').forEach((faq) => {
    const tabs = $$('.bs-tab', faq);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', t === tab); });
      $$('.bs-qa', faq).forEach((q) => { q.hidden = tab.dataset.bsTopic !== 'all' && q.dataset.topic !== tab.dataset.bsTopic; });
    }));
  });

  /* offer bar: counts down to a real end date set in the theme editor; hides itself once that date has passed */
  $$('[data-bs-promo]').forEach((bar) => {
    const end = Date.parse(bar.dataset.end || '');
    const clock = $('[data-bs-countdown]', bar);
    if (!end || !clock) { if (clock) clock.remove(); return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { bar.remove(); return false; }
      clock.textContent = `${Math.floor(s / 86400)}d ${pad(Math.floor(s / 3600) % 24)}h ${pad(Math.floor(s / 60) % 60)}m ${pad(s % 60)}s`;
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  });

  /* advertorial sticky CTA: after the hero picture has left the screen */
  const advSticky = $('[data-bs-adv-sticky]');
  const advHero = $('.bs-adv figure');
  if (advSticky && advHero && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      advSticky.classList.toggle('is-on', on);
      advSticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      const a = $('a', advSticky); if (a) a.tabIndex = on ? 0 : -1;
    }).observe(advHero);
  }

  /* video loops: play only while on screen (saves data and battery), poster stays when motion is reduced */
  const vids = $$('.bs-vid video');
  if (vids.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.muted = true; v.play().catch(() => {}); } else v.pause();
    }), { rootMargin: '120px 0px', threshold: 0.2 });
    vids.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); v.addEventListener('playing', () => v.classList.add('is-on'), { once: true }); vio.observe(v); });
  }

  /* TikTok wall: the player iframe is built only after a tap, inside the dialog (the reader never leaves the page) */
  const ttDialog = $('#bs-tt-dialog');
  if (ttDialog) {
    const frame = $('[data-bs-tt-frame]', ttDialog);
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-bs-tt]');
      if (!t) return;
      const id = t.dataset.bsTt.replace(/\D/g, '');
      if (!id) return;
      frame.innerHTML = `<iframe src="https://www.tiktok.com/player/v1/${id}?autoplay=1&loop=1&rel=0&music_info=0&description=0" title="TikTok video" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>`;
      ttDialog.showModal();
      // focus the close button, not the player: keys inside a cross-origin iframe never reach the dialog, so Esc only works from here
      ttDialog.querySelector('[data-bs-close]')?.focus();
    });
    ttDialog.addEventListener('close', () => { frame.innerHTML = ''; });
  }

  /* turn-around stage: load model-viewer once the section is near, then each beat on screen turns the camera */
  $$('[data-bs-turn]').forEach((sec) => {
    const mv = $('model-viewer', sec);
    const beats = $$('[data-bs-beat]', sec);
    const dots = $$('[data-bs-dot]', sec);
    if (!mv) return;
    let loaded = false;
    const load = () => {
      if (loaded) return; loaded = true;
      if (!customElements.get('model-viewer')) { const s = document.createElement('script'); s.type = 'module'; s.src = sec.dataset.bsMv; document.head.appendChild(s); }
      if (mv.dataset.src) mv.setAttribute('src', mv.dataset.src);
    };
    const narrow = matchMedia('(max-width: 989px)');
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    // phones: pull the camera back so nothing clips (AD R2 P0-1): × 1.15 for the assembled shoe (× 1.3 left it at ~55 % of the stage width,
    // look-dev 31-10), × 1.3 for the taller exploded stack (× 1.15 cut the outsole off at the bottom)
    const fitOrbit = (o, k) => (narrow.matches ? o.replace(/(\d+(?:\.\d+)?)%\s*$/, (m, r) => `${Math.round(r * k)}%`) : o);
    // explode: tween the model's own animation (frame 1 assembled → last frame apart) instead of playing it
    let tween = 0;
    const explodeTo = (k) => {
      const dur = mv.duration || 0;
      if (!dur) { mv.dataset.pending = String(k); return; }
      mv.pause();
      const from = mv.currentTime || 0, to = Math.min(dur - 0.001, Math.max(0, k * dur));
      cancelAnimationFrame(tween);
      if (still || Math.abs(to - from) < 0.01) { mv.currentTime = to; return; }
      const t0 = performance.now(), ms = 800;
      const step = (now) => {
        const p = Math.min(1, (now - t0) / ms), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        mv.currentTime = from + (to - from) * e;
        if (p < 1) tween = requestAnimationFrame(step);
      };
      tween = requestAnimationFrame(step);
    };
    mv.addEventListener('load', () => { mv.pause(); mv.currentTime = 0; if (mv.dataset.pending) explodeTo(Number(mv.dataset.pending)); });
    let cur = -1;
    const setBeat = (i) => {
      if (i < 0 || i === cur) return; cur = i;
      beats.forEach((b, j) => b.classList.toggle('is-on', j === i));
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
      const b = beats[i];
      if (b.dataset.target) mv.setAttribute('camera-target', b.dataset.target);
      if (b.dataset.orbit) mv.setAttribute('camera-orbit', fitOrbit(b.dataset.orbit, Number(b.dataset.explode) > 0 ? 1.3 : 1.15));
      explodeTo((Number(b.dataset.explode) || 0) / 100);
    };
    if (!('IntersectionObserver' in window)) { load(); return; }
    // the stage now sits right under the buy box (owner 31-10): wait for the page's own load so the 2 MB model never competes with the LCP picture
    const arm = () => new IntersectionObserver((es, o) => { if (es.some((e) => e.isIntersecting)) { load(); o.disconnect(); } }, { rootMargin: '800px 0px' }).observe(sec);
    if (document.readyState === 'complete') arm(); else addEventListener('load', arm, { once: true });
    // a beat turns on when its card is the most centred one in the reading band (phones: between the pinned stage and the sticky
    // Add-to-cart bar; desktop: the screen). Read from scroll position, not IO thresholds: short beats let two cards pass a threshold
    // at once and the camera jumped back (owner 31-10: scrolling past the stage must feel easy). Capture: the theme may scroll a wrapper.
    const cards = beats.map((b) => b.querySelector('.bs-turn__card') || b);
    const stage = $('.bs-turn__stage', sec), bar = $('.bs-sticky');
    let raf = 0;
    const pick = () => {
      raf = 0;
      const sr = sec.getBoundingClientRect();
      if (sr.bottom < 0 || sr.top > innerHeight) return;
      const br = bar && getComputedStyle(bar).visibility !== 'hidden' ? bar.getBoundingClientRect() : null;
      const lo = narrow.matches ? stage.getBoundingClientRect().bottom : 0, hi = br && br.top < innerHeight ? br.top : innerHeight, mid = (lo + hi) / 2;
      let best = -1, bd = Infinity;
      cards.forEach((c, i) => {
        const r = c.getBoundingClientRect(), vis = (Math.min(r.bottom, hi) - Math.max(r.top, lo)) / r.height, d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (vis >= 0.6 && d < bd) { bd = d; best = i; }
      });
      setBeat(best);
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(pick); }, { passive: true, capture: true });
    pick();
  });

  /* review wall: open the remaining cards in place */
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-bs-more]'); if (b) b.closest('[data-bs-reviews]')?.classList.add('is-open'); });

  const main = $('[data-bs-main]');
  if (!main) return;
  let data = {};
  try { data = JSON.parse($('[data-bs-data]', main).textContent); } catch (e) { data = { variants: [] }; }
  const money = (cents) => (data.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
    const v = (cents / 100).toFixed(2);
    return k === 'amount_no_decimals' ? Math.round(cents / 100).toString() : v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  });

  /* gallery */
  const track = $('[data-bs-track]', main);
  const slides = track ? $$('.bs-gallery__slide', track) : [];
  const thumbs = $$('[data-bs-thumb]', main);
  const count = $('[data-bs-count]', main);
  let cur = 0;
  const setCur = (i) => {
    cur = i;
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
    if (count) count.textContent = String(i + 1);
    const th = thumbs[i];
    if (th && th.parentElement) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: smooth });
  };
  const show = (i) => { const s = slides[Math.max(0, Math.min(slides.length - 1, i))]; if (s && track) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth }); };
  if (track && 'IntersectionObserver' in window) {
    const gio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > .6) setCur(slides.indexOf(e.target)); }), { root: track, threshold: [.6] });
    slides.forEach((s) => gio.observe(s));
  }
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  $('[data-bs-prev]', main)?.addEventListener('click', () => show(cur - 1));
  $('[data-bs-next-slide]', main)?.addEventListener('click', () => show(cur + 1));
  track?.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'ArrowLeft') show(cur - 1); });

  /* colour: the first slide shows that colour's real photo and the gallery comes into view (E3) */
  const hero = $('[data-bs-hero]', main);
  const heroOrig = hero ? { src: hero.getAttribute('src'), srcset: hero.getAttribute('srcset'), alt: hero.alt } : null;
  const colourPhotos = {};
  const tpl = $('template[data-bs-colour-photos]', main);
  if (tpl) $$('img', tpl.content).forEach((im) => { colourPhotos[im.dataset.colour] = im; });
  const colourName = $('[data-bs-colour-name]', main);
  const sizeName = $('[data-bs-size-name]', main);
  const state = { colour: $('input[name="bs-colour"]:checked', main)?.value || '', size: '', tier: 1 };
  const variantInput = $('[data-bs-variant]', main);
  const findVariant = (c, s) => (data.variants || []).find((v) => v.c === c && v.s === s);
  const setColour = (v, fromUser) => {
    state.colour = v;
    if (colourName) colourName.textContent = v;
    $$('[data-bs-pair-colour]', main).forEach((s) => { if (!s.dataset.touched) s.value = v; });
    const ph = colourPhotos[v];
    if (hero && fromUser) {
      if (ph) { hero.setAttribute('srcset', ph.getAttribute('srcset')); hero.setAttribute('src', ph.getAttribute('src')); hero.alt = ph.alt; }
      else if (heroOrig) { hero.setAttribute('srcset', heroOrig.srcset || ''); hero.setAttribute('src', heroOrig.src); hero.alt = heroOrig.alt; }
      show(Math.max(0, slides.indexOf(hero.closest('.bs-gallery__slide'))));
      const r = track ? track.getBoundingClientRect() : null;
      if (r && (r.top < 0 || r.top > innerHeight * .5)) goTo(track, 'start');
    }
    sync();
  };
  $$('input[name="bs-colour"]', main).forEach((r) => r.addEventListener('change', () => setColour(r.value, true)));
  $$('[data-bs-pick-colour]').forEach((b) => b.addEventListener('click', () => {
    const r = $(`input[name="bs-colour"][value="${CSS.escape(b.dataset.bsPickColour)}"]`, main);
    if (r) { r.checked = true; setColour(r.value, true); goTo(track, 'start'); }
  }));
  $$('input[name="bs-size"]', main).forEach((r) => r.addEventListener('change', () => {
    state.size = r.value; if (sizeName) sizeName.textContent = r.value;
    r.closest('.bs-opt')?.classList.remove('is-missing');
    $$('[data-bs-pair-size]', main).forEach((s) => { if (!s.dataset.touched) s.value = r.value; });
    sync();
  }));
  $$('[data-bs-pair] select', main).forEach((s) => s.addEventListener('change', () => { s.dataset.touched = '1'; }));

  /* packs */
  const pairs = $('[data-bs-pairs]', main);
  const totalEls = [...$$('[data-bs-buy-total]', main), $('[data-bs-sticky-total2]', main)];
  function sync() {
    const t = $('input[name="bs-tier"]:checked', main);
    state.tier = Number(t?.value || 1);
    if (pairs) {
      pairs.hidden = state.tier < 2;
      $$('[data-bs-pair]', main).forEach((p) => { p.hidden = Number(p.dataset.bsPair) > state.tier; });
    }
    totalEls.forEach((el) => { if (el && t) el.textContent = money(Number(t.dataset.total)); });
    const v = findVariant(state.colour, state.size);
    if (v && variantInput) variantInput.value = v.id;
  }
  $$('input[name="bs-tier"]', main).forEach((r) => r.addEventListener('change', sync));
  sync();

  /* cart: one cart/add.js with every pair, the pack code on the cart, then the theme drawer (or /cart) */
  const form = $('#bs-form');
  const msg = $('[data-bs-msg]', main);
  const say = (t) => { if (!msg) return; msg.textContent = t; msg.hidden = !t; };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const post = (path, body) => fetch(`${root}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  let busy = false;
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    say('');
    if (!state.size) { const f = $('.bs-sizes', main)?.closest('.bs-opt'); f?.classList.add('is-missing'); goTo(f, 'center'); say(data.needSize || 'Please choose your size first.'); return; }
    const first = findVariant(state.colour, state.size);
    if (!first) { say('That colour and size is not available.'); return; }
    const items = [first.id];
    for (let i = 2; i <= state.tier; i++) {
      const p = $(`[data-bs-pair="${i}"]`, main);
      const c = $('[data-bs-pair-colour]', p)?.value || state.colour;
      const s = $('[data-bs-pair-size]', p)?.value;
      if (!s) { say(data.needPairSize || 'Please choose a size for each pair.'); $('[data-bs-pair-size]', p)?.focus(); return; }
      const v = findVariant(c, s);
      if (!v) { say(`Pair ${i}: that colour and size is not available.`); return; }
      items.push(v.id);
    }
    if (data.preview) { say(data.previewNote || 'Preview: the cart opens once this product is live.'); return; }
    const merged = {};
    items.forEach((id) => { merged[id] = (merged[id] || 0) + 1; });
    busy = true;
    const btn = $('[data-bs-buy]', main);
    btn?.setAttribute('aria-busy', 'true');
    try {
      const res = await post('cart/add.js', { items: Object.entries(merged).map(([id, quantity]) => ({ id: Number(id), quantity })) });
      if (!res.ok) throw new Error(`cart/add ${res.status}`);
      const code = $('input[name="bs-tier"]:checked', main)?.dataset.code;
      if (code) await post('cart/update.js', { discount: code });
      if (window.croCartDrawer && typeof window.croCartDrawer.refresh === 'function') window.croCartDrawer.refresh({ open: true });
      else window.location.href = `${root}cart`;
    } catch (err) {
      say('Sorry, something went wrong. Please try again.');
    } finally { busy = false; btn?.removeAttribute('aria-busy'); }
  }, true);

  /* sticky bar: as soon as the quick buy button under the price leaves the screen (the pack button lower down can share the screen with it); it buys when a size is chosen */
  $('[data-bs-sticky-buy]', main)?.addEventListener('click', () => {
    if (!state.size) { const f = $('.bs-sizes', main)?.closest('.bs-opt'); f?.classList.add('is-missing'); goTo(f, 'center'); say(data.needSize || 'Please choose your size first.'); return; }
    if (form && form.requestSubmit) form.requestSubmit(); else form?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });
  const sticky = $('[data-bs-sticky]', main);
  const buyBtns = $$('[data-bs-quick]', main).length ? $$('[data-bs-quick]', main) : $$('[data-bs-buy]', main);
  if (sticky && buyBtns.length && 'IntersectionObserver' in window) {
    const seen = new Map();
    const sio = new IntersectionObserver((es) => {
      es.forEach((e) => seen.set(e.target, e.isIntersecting));
      const on = ![...seen.values()].some(Boolean);
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      const a = $('button', sticky); if (a) a.tabIndex = on ? 0 : -1;
    });
    buyBtns.forEach((b) => sio.observe(b));
  }
})();
